"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createId = createId;

/**
 * Creates a unique id to distinguish parallax elements.
 * @return {Number}
 */
var id = 0;

function createId() {
  ++id;
  return id;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scroll-parallax/cjs/utils/createId.js
// module id = 79
// module chunks = 0